<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	// Stores
	import { cancelBetId } from '@/Stores/Store.js';
	import BetHistoryStore from '@/Stores/User/BetHistoryStore.js';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import TextAreaInput from '@/Components/TextAreaInput.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';
	import { CurrencyFormat } from '@/Services/Helpers';

	export let store;

	const dispatch = createEventDispatcher();

	let sending = false;
	let open = false;
	let note = '';

	$: open = $cancelBetId;
	$: bet = open && $cancelBetId && store && store.firstWhere('id', $cancelBetId);

	function confirmClicked() {
		if (!note) return;

		sending = true;
		BetHistoryStore.cancelUserBet(bet.id, {
			note
		})
			.then(() => {
				notify({
					type: 'success',
					title: `Bet Ticket #${bet.ticket}`,
					message: 'Bet Cancelled.',
					timeout: 3
				});
				dispatch('saved');
				onClose();
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Bet Cancel Failed',
					message: e.adjusted_amount || 'Problem cancelling bet',
					timeout: 5
				});
			})
			.finally(() => {
				sending = false;
			});
	}

	function onClose() {
		note = '';
		cancelBetId.set(false);
	}
</script>

{#if open && bet}
	<Modal on:close={onClose} className="w-1/2 md:max-w-2xl">
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">Cancel Bet</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<p>
				Bet Ticket #{bet.ticket}
				{#if bet.user && bet.user.pin}for PIN: {bet.user && bet.user.pin}{/if}
			</p>
			<p>
				<span class="font-semibold">Status:</span>
				{bet.status.name}
				<span class="ml-2 font-semibold">Bet Amount:</span>
				{CurrencyFormat(bet.bet_amount)}
			</p>
			<TextAreaInput
				name="note"
				className="py-4 w-full"
				bind:value={note}
				required={true}
				placeholder="Reason for cancelling"
			/>
			<LoadingButton on:click={confirmClicked} loading={sending} className="mb-4 btn btn-primary">Save</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={onClose}>Cancel</button>
		</div>
	</Modal>
{/if}
